<template>
  <div class="page-title">{{ $t("notices_page_title") }}</div>
  <div class="intro">{{ $t("notices_subtitle") }}</div>

  <el-container>
    <el-aside width="300px">
      <div>{{ $t("filter_by") }}</div>
      <el-collapse v-model="activeName" @change="handleChange" accordion>
        <el-collapse-item :title="$t('date')" name="1">
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: date_sorting == 'ASC' }"
                @click="changeDateSorting('ASC')"
              >
                {{ $t("newest_first") }}
              </li>
              <li
                v-bind:class="{ active: date_sorting == 'DESC' }"
                @click="changeDateSorting('DESC')"
              >
                {{ $t("oldest_first") }}
              </li>
              <li>
                <el-checkbox
                  class="gkt-checkbox"
                  v-model="single_days"
                  :label="$t('single_days')"
                  border
                ></el-checkbox>

                <el-date-picker
                  v-if="single_days"
                  class="gkt-date-picker"
                  type="dates"
                  size="mini"
                  v-model="dates"
                  @change="setFilterDate()"
                  :placeholder="$t('pick_one_or_more_days')"
                >
                </el-date-picker>
                <el-date-picker
                  v-if="!single_days"
                  class="gkt-date-picker"
                  v-model="date_range"
                  type="daterange"
                  size="mini"
                  unlink-panels
                  :range-separator="$t('to')"
                  :start-placeholder="$t('start')"
                  :end-placeholder="$t('end')"
                  :shortcuts="shortcuts"
                  @change="setFilterDate()"
                >
                </el-date-picker>
                <el-checkbox
                  v-if="showTransmiteDates"
                  class="gkt-checkbox"
                  v-model="show_transferdate"
                  :label="$t('show_transferdate')"
                  border
                ></el-checkbox>
                <el-checkbox
                  class="gkt-checkbox"
                  v-model="notice_open"
                  :label="$t('notice_sort')"
                  border
                ></el-checkbox>
              </li>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="$t('location')" name="2">
          <div class="actions">
            <ul>
              <li
                :class="{ active: location_sorting == 'ASC' }"
                @click="changeLocationSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                :class="{ active: location_sorting == 'DESC' }"
                @click="changeLocationSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('location')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_location"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="$t('provider')" name="3">
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: provider_sorting == 'ASC' }"
                @click="changeProviderSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                v-bind:class="{ active: provider_sorting == 'DESC' }"
                @click="changeProviderSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('provider')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_provider"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>
      </el-collapse>

      <el-button
        style="display:block;margin: 0 auto;margin-top: 48px;"
        type="default"
        @click="csvExport"
        icon="el-icon-paperclip"
        >{{ $t("export_to_csv") }}</el-button
      >
    </el-aside>
    <el-main>
      <table
        v-loading="loading"
        :element-loading-text="$t('loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <thead>
          <tr>
            <td class="td_date">{{ $t("date") }}</td>
            <td class="td_date" v-if="show_transferdate">
              {{ $t("date") }}
            </td>
            <td class="td_min_width">{{ $t("location") }}</td>
            <td class="td_min_width">{{ $t("provider") }}</td>
            <td class="td_notice_width">{{ $t("notices_tableheader") }}</td>
            <td v-if="store.state.login_type == 'mandate'" class="td_action">
              {{ $t("notice_actions") }}
            </td>
          </tr>
        </thead>
        <tbody
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          style="overflow-y:scroll"
        >
          <tr
            v-for="i in filteredAndSortedData"
            v-bind:key="i"
            class="infinite-list-item"
          >
            <td class="td_date" style="text-align:left;vertical-align:top">
              {{ i.date }}
            </td>
            <td
              class="td_date"
              v-if="show_transferdate"
              style="text-align:left;vertical-align:top"
            >
              {{ i.date_created }}
            </td>
            <td class="td_min_width" style="text-align:left;vertical-align:top">
              {{ i.location }}
            </td>
            <td class="td_min_width" style="text-align:left;vertical-align:top">
              {{ i.provider }}
            </td>
            <td
              class="td_notice_width"
              style="text-align:left;vertical-align:top;line-height:1em;word-wrap: break-word;"
            >
              {{ i.notice }}
            </td>
            <td
              class="td_action"
              style="text-align:left;vertical-align:top"
              v-if="i.state == 'created' && store.state.login_type == 'mandate'"
            >
              <el-popconfirm
                )
                :confirmButtonText="$t('yes')"
                :cancelButtonText="$t('no')"
                :title="$t('setnotice_prompt')"
                @confirm="setnotice(i.idnotice)"
              >
                <template #reference>
                  <el-button
                    style="display:block;margin: 0 auto;padding:5px;padding-left:10px;"
                    type="default"
                    icon="el-icon-circle-check"
                    >{{ $t("setnotice_msg") }}</el-button
                  >
                </template>
              </el-popconfirm>
            </td>
            <td
              class="td_action"
              style="text-align:center;vertical-align:top"
              v-if="i.state == 'done' && store.state.login_type == 'mandate'"
            >
              {{ $t("setnotice_done") }}
            </td>
            <td
              class="td_action"
              style="text-align:left;vertical-align:top"
              v-if="
                i.state != 'done' &&
                  i.state != 'created' &&
                  store.state.login_type == 'mandate'
              "
            ></td>
          </tr>
        </tbody>
      </table>
      <el-alert
        v-if="noMore"
        :title="$t('all_services_loaded')"
        type="success"
        center
        show-icon
      >
      </el-alert>
    </el-main>
  </el-container>
</template>

<style lang="scss" scoped>
.td_min_width {
  width: 20%;
}
.td_date {
  width: 18%;
}
.td_notice_width {
  width: 35%;
}
.td_action {
  width: 7%;
}
.el-container {
  margin-top: 24px;
  max-height: calc(100% - 124px);
  border-radius: 24px;
}
:deep(div.gkt-date-picker) {
  width: 180px;

  input {
    font-size: 9px;
  }

  span.el-range-separator {
    font-size: 8px;
    width: 22px;
  }
}

:deep(label.gkt-checkbox) {
  display: block;
  margin-bottom: 6px;
  color: $gkt-white !important;

  span {
    color: $gkt-white !important;
  }
}

.actions {
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    padding: 12px 0;

    li {
      cursor: pointer;
      margin-bottom: 8px;
      display: block;
      color: $gkt-white;

      &.active {
        font-weight: bold;
      }
    }
  }
}

.el-aside {
  background-color: $gkt-orange;
  border-top-left-radius: 21px;
  border-bottom-left-radius: 21px;
  padding: 24px 48px;
  padding-right: 72px;

  .el-collapse {
    margin-top: 24px;
    border: 0;

    .el-collapse-item {
      :deep(.el-collapse-item__header),
      :deep(.el-collapse-item__wrap) {
        background-color: transparent !important;
        color: #ffffff;
        font-weight: normal;
      }

      :deep(.el-collapse-item__header) {
        border-bottom-color: #fdfdfd;
      }
    }
  }
}

.el-main {
  padding: 0;
  background-color: $gkt-light-grey;
  padding: 24px;
  border-radius: 21px;
  position: relative;
  margin-left: -42px;

  table {
    height: calc(100% - 100px);
    margin-bottom: 24px;
    border-collapse: collapse;

    @media screen and(max-width: 1021px) {
      width: 837px;
      overflow: scroll;
    }

    thead {
      display: block;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        visibility: hidden;
      }

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        td {
          text-align: center;
          border-right: 3px solid #ffffff;
          border-bottom: 3px solid #ffffff;
          font-weight: 500;
          padding: 6px;
          word-break: normal;

          &:last-child {
            border-right: 0;
          }
        }
      }
    }

    tbody {
      display: block;
      height: calc(100% - 24px);
      overflow: auto;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        &:nth-child(even) {
          background-color: darken($gkt-light-grey, 2);
        }

        td {
          text-align: center;
          border-right: 3px solid #ffffff;
          padding: 6px;

          word-break: normal;

          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";
export default {
  setup() {
    provide("store", store);
  },

  name: "notice",
  data() {
    return {
      single_days: false,
      notice_open: false,
      show_transferdate: false,
      shortcuts: [
        {
          text: this.$t("last_week"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })()
        },
        {
          text: this.$t("last_month"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })()
        },
        {
          text: this.$t("last_3_months"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })()
        }
      ],
      dates: "",
      date_range: "",
      activeName: ["1"],
      notices: [],
      locations: [],
      count: 0,
      tab_index: 1,
      loading: false,
      current_sorter: "date",
      search_location: "",
      search_provider: "",
      search_service: "",
      search_date: "",
      location_sorting: "ASC",
      date_sorting: "ASC",
      service_sorting: "ASC",
      provider_sorting: "ASC",
      filter_date: "",
      store
    };
  },
  computed: {
    noMore() {
      return this.count >= 50;
    },
    showTransmiteDates() {
      if (window.location.search.search("showtransmitdate=1") >= 0) {
        return true;
      }
      return false;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    filteredAndSortedData() {
      let result = this.notices;
      let location_sorting = this.location_sorting;
      let date_sorting = this.date_sorting;
      let provider_sorting = this.provider_sorting;
      let service_sorting = this.service_sorting;
      let tmp_result = result;
      let sorter = this.current_sorter;
      let filter_date = this.filter_date;
      let single_days = this.single_days;
      let notice_open = this.notice_open;
      let dates = [];

      if (filter_date !== "") {
        for (let index in filter_date) {
          const date = filter_date[index];

          const formattedDate = new Date(date);

          formattedDate.setDate(formattedDate.getDate() + 1);
          const check_date_formatted = formattedDate
            .toISOString()
            .split("T")[0];

          dates.push(check_date_formatted);
        }
      }

      if (sorter == "date") {
        tmp_result = tmp_result.sort(function(a, b) {
          return date_sorting == "ASC"
            ? -a.date.localeCompare(b.date)
            : a.date.localeCompare(b.date);
        });
      }
      if (notice_open) {
        tmp_result = tmp_result.filter(function(d) {
          return d.state == "created";
        });
      }
      if (single_days) {
        if (dates.length) {
          tmp_result = tmp_result.filter(function(d) {
            const formattedDate = new Date(d.date);
            const check = formattedDate.toISOString().split("T")[0];
            return dates.includes(check);
          });
        }
      } else {
        if (dates.length) {
          tmp_result = tmp_result.filter(function(d) {
            const formattedDate = new Date(d.date);
            const check = formattedDate.toISOString().split("T")[0];

            if (dates[0] == dates[1]) {
              return check == dates[0];
            }

            return check >= dates[0] && check <= dates[1];
          });
        }
      }

      if (sorter == "location") {
        tmp_result = tmp_result.sort(function(a, b) {
          return location_sorting == "ASC"
            ? a.location.localeCompare(b.location)
            : -a.location.localeCompare(b.location);
        });
      }

      if (this.search_location != "") {
        let search_location = this.search_location.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.location.toLowerCase().indexOf(search_location) !== -1;
        });
      }

      if (sorter == "provider") {
        tmp_result = tmp_result.sort(function(a, b) {
          return provider_sorting == "ASC"
            ? a.provider.localeCompare(b.provider)
            : -a.provider.localeCompare(b.provider);
        });
      }

      if (this.search_provider != "") {
        let search_provider = this.search_provider.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.provider.toLowerCase().indexOf(search_provider) !== -1;
        });
      }

      if (sorter == "service") {
        tmp_result = tmp_result.sort(function(a, b) {
          return service_sorting == "ASC"
            ? a.service.localeCompare(b.service)
            : -a.service.localeCompare(b.service);
        });
      }

      if (this.search_service != "") {
        let search_service = this.search_service.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.service.toLowerCase().indexOf(search_service) !== -1;
        });
      }
      return tmp_result;
    }
  },
  methods: {
    async setnotice(id) {
      const parameters = {
        identry: id
      };

      const response = await this.$root.store.methods.apiRequest(
        "setnoticestate",
        parameters
      );
      const res = response.data;
      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("setnotice_success"),
          type: "success",
          offset: 350
        });

        this.notices = response.data.results.notices;
      } else {
        this.$message({
          showClose: true,
          message: this.$t("setnotice_fail"),
          type: "error",
          offset: 350
        });
      }
    },
    csvExport() {
      let csvContent = "";
      const arrData = this.filteredAndSortedData;

      csvContent += [
        this.$t("date") +
          ";" +
          this.$t("location") +
          ";" +
          this.$t("provider") +
          ";" +
          this.$t("notices_tableheader") +
          ";" +
          this.$t("notice_actions"),
        ...arrData.map(
          item =>
            item.date +
            ';"' +
            item.location.replace(/"/g, '""') +
            '";"' +
            item.provider.replace(/"/g, '""') +
            '";"' +
            item.notice.replace(/"/g, '""') +
            '";"' +
            (item.state == "created"
              ? this.$t("setnotice_open")
              : this.$t("setnotice_done")) +
            '"'
        )
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const csvString = csvContent;
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvString)
      );
      link.setAttribute("download", "export.csv");
      link.click();
    },
    setFilterDate() {
      if (this.single_days) {
        this.date_range = "";
        this.filter_date = this.dates;
      } else {
        this.dates = "";
        this.filter_date = this.date_range;
      }
    },
    handleChange(val) {
      this.tab_index = val;

      if (val == 1) {
        this.current_sorter = "date";
      }

      if (val == 2) {
        this.current_sorter = "location";
      }

      if (val == 3) {
        this.current_sorter = "provider";
      }

      if (val == 4) {
        this.current_sorter = "service";
      }
    },
    changeCurrentSorting(val) {
      this.current_sorter = val;
    },
    changeLocationSorting(sort) {
      this.location_sorting = sort;

      this.current_sorter = "location";
    },
    changeProviderSorting(sort) {
      this.provider_sorting = sort;

      this.current_sorter = "provider";
    },
    changeDateSorting(sort) {
      this.date_sorting = sort;

      this.current_sorter = "date";
    },
    changeServiceSorting(sort) {
      this.service_sorting = sort;

      this.current_sorter = "service";
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 10;
        this.loading = false;
      }, 250);
    }
  },
  async mounted() {
    const response = await this.$root.store.methods.apiRequest("getnotices");
    const res = response.data;
    if (res.results && res.results.notices && res.results.notices.length > 0) {
      this.notices = res.results.notices;
    }
  }
};
</script>
